<template>
  <div class="error-page">
    <div class="error-content">
      <div class="error-code">404</div>
      <div class="error-msg">页面不存在</div>
      <p class="error-desc">抱歉，您访问的页面不存在或已被删除</p>
      <el-button type="primary" size="mini" @click="$router.push('/')">返回首页</el-button>
    </div>
  </div>
</template>

<script>
export default { name: 'Page404' }
</script>

<style lang="scss" scoped>
.error-page {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f2f5;
  .error-content {
    text-align: center;
    .error-code {
      font-size: 120px;
      font-weight: 700;
      color: #409eff;
      line-height: 1;
      margin-bottom: 16px;
    }
    .error-msg {
      font-size: 28px;
      color: #303133;
      margin-bottom: 12px;
    }
    .error-desc {
      color: #909399;
      margin-bottom: 24px;
    }
  }
}
</style>
